<mat-card class="nepraunik-card" style="min-height: 100% !important;;max-width: 100%;">
  <router-outlet></router-outlet>
  <!-- <vertrag-list></vertrag-list> -->
</mat-card>


// WEBPACK FOOTER //
// ./src/app/_vertrag/vertrag.component.html